module.exports = __webpack_public_path__ + "static/img/bilibili@2x.d6ddc40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bilibili@2x.png
// module id = SQhr
// module chunks = 12